(function () {
  if (window.agibotX2DetailsInstalled) return;
  window.agibotX2DetailsInstalled = true;

  function initCarousel(root) {
    var viewport = root.querySelector('.x2-carousel-viewport');
    var slides = Array.from(root.querySelectorAll('.yg-image-slide-item'));
    var controls = root.querySelector('.yg-image-pagination');
    if (!viewport || !slides.length || !controls) return;
    var index = 0, timer, manualPause = false, dragX = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var dots = [];
    var currentWidth = viewport.clientWidth;
    function fitActiveSlide() {
      var active = slides[index];
      if (active) viewport.style.height = active.getBoundingClientRect().height + 'px';
    }
    function select(next) {
      index = (next + slides.length) % slides.length;
      root.dataset.slide = String(index);
      viewport.scrollTo({left: index * viewport.clientWidth, behavior: reduceMotion.matches ? 'instant' : 'smooth'});
      updateDots();
    }
    function updateDots() {
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', String(i === index)); });
      fitActiveSlide();
    }
    function resetTimer() {
      clearInterval(timer);
      if (manualPause || reduceMotion.matches) return;
      timer = setInterval(function () {
        if (!root.isConnected) { clearInterval(timer); return; }
        var rect = root.getBoundingClientRect();
        if (!document.hidden && rect.top < window.innerHeight && rect.bottom > 0 &&
            !root.matches(':hover') && !root.contains(document.activeElement)) select(index + 1);
      }, 5000);
    }
    function makeButton(label, text, handler) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'x2-carousel-control';
      button.setAttribute('aria-label', label);
      button.textContent = text;
      button.addEventListener('click', handler);
      return button;
    }
    controls.replaceChildren();
    controls.append(makeButton('Previous slide', '‹', function () { select(index - 1); resetTimer(); }));
    slides.forEach(function (slide, i) {
      slide.classList.remove('swiper-slide');
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-label', (i + 1) + ' of ' + slides.length);
      var dot = makeButton('Go to slide ' + (i + 1), '', function () { select(i); resetTimer(); });
      dot.className = 'x2-carousel-dot';
      dots.push(dot);
      controls.append(dot);
      var content = slide.querySelector('.yg-image-slide-content');
      var more = slide.querySelector('.yg-learn-more');
      if (content && more) {
        more.hidden = false;
        more.addEventListener('click', function () {
          var expanded = content.classList.toggle('x2-text-expanded');
          more.textContent = expanded ? 'Show Less' : 'Learn More';
          more.setAttribute('aria-expanded', String(expanded));
        });
      }
    });
    controls.append(makeButton('Next slide', '›', function () { select(index + 1); resetTimer(); }));
    var pause = makeButton('Pause slideshow', 'Ⅱ', function () {
      manualPause = !manualPause;
      pause.textContent = manualPause ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', manualPause ? 'Play slideshow' : 'Pause slideshow');
      resetTimer();
    });
    controls.append(pause);
    viewport.addEventListener('scroll', function () {
      index = Math.round(viewport.scrollLeft / (viewport.clientWidth || 1));
      root.dataset.slide = String(index);
      updateDots();
    }, {passive:true});
    viewport.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      select(index + (event.key === 'ArrowRight' ? 1 : -1));
      resetTimer();
    });
    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && !event.target.closest('button,a')) dragX = event.clientX;
    });
    viewport.addEventListener('pointerup', function (event) {
      if (dragX !== null && Math.abs(event.clientX - dragX) > 40) {
        select(index + (event.clientX < dragX ? 1 : -1)); resetTimer();
      }
      dragX = null;
    });
    viewport.addEventListener('pointercancel', function () { dragX = null; });
    viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });
    var observer = new ResizeObserver(function () {
      if (!root.isConnected) { observer.disconnect(); clearInterval(timer); return; }
      if (currentWidth !== viewport.clientWidth) {
        currentWidth = viewport.clientWidth;
        viewport.scrollTo({left: index * currentWidth, behavior:'instant'});
      }
      fitActiveSlide();
    });
    observer.observe(viewport);
    slides.forEach(function (slide) { observer.observe(slide); });
    select(0);
    resetTimer();
  }

  function initComparison(panel) {
    var button = panel.querySelector('.yg-switch-modal-button button');
    var expanded = false;
    function syncRows() {
      var columns = Array.from(panel.querySelectorAll('.yg-switch-modal-wrapper')).map(function (wrapper) {
        return Array.from(wrapper.querySelectorAll('.product-modal-text.active .metafield-rich_text_field > p'));
      });
      columns.flat().forEach(function (row) { row.style.minHeight = ''; });
      for (var i = 0; i < columns.length; i += 2) {
        if (!columns[i + 1]) continue;
        columns[i].forEach(function (row, index) {
          var other = columns[i + 1][index];
          if (!other || row.hidden || other.hidden) return;
          var height = Math.max(row.offsetHeight, other.offsetHeight);
          row.style.minHeight = other.style.minHeight = height + 'px';
        });
      }
    }
    function render() {
      panel.dataset.expanded = String(expanded);
      panel.querySelectorAll('.product-modal-text').forEach(function (text) {
        text.querySelectorAll('.metafield-rich_text_field > p').forEach(function (row, index) {
          row.hidden = !expanded && index >= 5;
          row.style.display = row.hidden ? 'none' : '';
        });
      });
      if (button) {
        button.textContent = expanded ? (button.dataset.hide || 'Show Less') : (button.dataset.more || 'Learn More');
        button.setAttribute('aria-expanded', String(expanded));
      }
      requestAnimationFrame(syncRows);
    }
    button?.addEventListener('click', function () {
      expanded = !expanded;
      render();
      if (!expanded) {
        var info = panel.querySelector('.yg-switch-product-info');
        if (info && info.getBoundingClientRect().top < 0) {
          info.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }
    });
    panel.querySelectorAll('.yg-switch-modal-wrapper').forEach(function (wrapper) {
      var select = wrapper.querySelector('.yg-switch-modal-select button');
      var options = wrapper.querySelector('.yg-switch-modal-accordions');
      select?.addEventListener('click', function () {
        options?.classList.toggle('active');
        select.setAttribute('aria-expanded', String(options?.classList.contains('active') || false));
      });
      var items = Array.from(wrapper.querySelectorAll('.yg-switch-accordion-item'));
      items.forEach(function (item, index) {
        item.addEventListener('click', function () {
          items.forEach(function (entry) { entry.classList.toggle('active', entry === item); });
          ['.yg-switch-product-image', '.product-modal-text'].forEach(function (selector) {
            wrapper.querySelectorAll(selector).forEach(function (entry, entryIndex) {
              entry.classList.toggle('active', entryIndex === index);
            });
          });
          var label = select?.querySelector('span');
          if (label) label.textContent = item.textContent.trim();
          options?.classList.remove('active');
          select?.setAttribute('aria-expanded', 'false');
          render();
        });
      });
    });
    render();
    var observer = new ResizeObserver(function () {
      if (!panel.isConnected) { observer.disconnect(); return; }
      requestAnimationFrame(syncRows);
    });
    observer.observe(panel);
    document.fonts?.ready.then(syncRows);
  }

  function init(root) {
    if (root.dataset.x2Initialized === 'true') return;
    root.dataset.x2Initialized = 'true';
    root.querySelectorAll('[data-x2-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-x2-comparison]').forEach(initComparison);
    root.querySelectorAll('details[data-x2-faq]').forEach(function (details) {
      // Native summary handles pointer and keyboard activation exactly once.
      details.addEventListener('toggle', function () {
        details.setAttribute('aria-expanded', String(details.open));
      });
    });
    root.querySelectorAll('yg-collapse').forEach(function (collapse) {
      if (customElements.get('yg-collapse')) return;
      var container = collapse.closest('.yg-collapse-container') || collapse.parentElement;
      var items = Array.from(collapse.querySelectorAll('.yg-collapse-item'));
      function activate(index) {
        items.forEach(function (entry, entryIndex) {
          var active = entryIndex === index;
          entry.classList.toggle('active', active);
          var header = entry.querySelector('.yg-collapse-item-header');
          header?.setAttribute('aria-expanded', String(active));
          var description = entry.querySelector('.yg-collapse-item-desc');
          if (description) {
            description.style.height = active ? 'auto' : '0px';
            description.style.paddingBlockStart = active ? '12px' : '0px';
          }
        });
        container.querySelectorAll('.yg-collapse-image').forEach(function (image, imageIndex) {
          image.classList.toggle('active', imageIndex === index);
        });
      }
      items.forEach(function (item, index) {
        var header = item.querySelector('.yg-collapse-item-header');
        header?.setAttribute('role', 'button');
        header?.setAttribute('tabindex', '0');
        header?.addEventListener('click', function () { activate(index); });
        header?.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(index); }
        });
      });
      activate(0);
    });
  }
  function boot() { document.querySelectorAll('[data-x2-detail-only]').forEach(init); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
